import React from "react";
import { Button } from "@mui/material";
import { CompareArrows as CompareArrowsIcon } from "@mui/icons-material";

interface CompareButtonProps {
    compareExpanded: boolean;
    onToggle: () => void;
    disabled?: boolean;
}

const CompareButton: React.FC<CompareButtonProps> = ({ 
    compareExpanded, 
    onToggle, 
    disabled = false 
}) => {
    return (
        <Button
            variant={compareExpanded ? "contained" : "outlined"}
            startIcon={<CompareArrowsIcon />}
            onClick={onToggle}
            disabled={disabled}
        >
            Compare
        </Button>
    );
};

export default CompareButton;
